// 系统
const system = {
  'common_system_ERP': { cn: 'ERP', en: 'ERP', kr: 'ERP' },
  'common_system_AMAZON_OPERATE': { cn: '亚马逊', en: 'Amazon', kr: 'Amazon' },
  'common_system_SYS_LISTING': { cn: '刊登', en: 'Listing', kr: 'Listing' },
  'common_system_TMS_SAAS': { cn: '易面单', en: 'EASY LAB', kr: 'EASY LAB' },
  'common_system_M2B': { cn: '分销', en: 'Distribution', kr: 'Distribution' },
  'common_system_EASY_BOOSTER': { cn: '易销宝', en: 'EASY BOOSTER', kr: 'EASY BOOSTER' },
  'common_system_Feature_Pack': { cn: '功能包', en: 'Feature-Pack', kr: '功能包' }
  // 'common_system_erp': { cn: '', en: '', kr: '' },
}

// 连词|动词|承接词|量词|介词|名词
const conj = {
  // 动词
  'common_conj_to': {
    cn: '去',
    en: 'Go to ',
    kr: '가기'
  },
  'common_conj_to2': {
    cn: '去{0}',
    en: 'To {0}',
    kr: '去{0}'
  },
  'common_conj_and': {
    cn: '和',
    en: ' and ',
    kr: '와'
  },
  // 承接词
  'common_conj_successfully_only': {
    cn: '成功',
    en: 'successfully',
    kr: '성공'
  },
  // 名词
  'common_conj_eccang': {
    cn: '深圳市易仓科技有限公司',
    en: 'Shenzhen Eccang Technology Co., Ltd',
    kr: '선전시 이창(易仓科技)테크놀로지'
  },
  'common_conj_DingTalk': {
    cn: '钉钉',
    en: 'DingTalk',
    kr: 'DingTalk'
  },
  'common_conj_WeChat': {
    cn: '微信',
    en: 'WeChat',
    kr: 'WeChat'
  },
  'common_conj_system': {
    cn: '系统',
    en: 'System ',
    kr: '시스템'
  },
  'common_conj_time': {
    cn: '时间',
    en: 'Time',
    kr: '시간'
  },
  'common_conj_time_duration': {
    cn: '时长',
    en: 'Time duration',
    kr: '시간'
  },
  'common_conj_type': {
    cn: '类型',
    en: 'type ',
    kr: '유형'
  },
  'common_conj_all': {
    cn: '全部{0}',
    en: 'All {0}',
    kr: '전부{0}'
  }
}

// 常用按钮
const btn = {
  'common_btn_submit': {
    cn: '提交',
    en: 'Submit',
    kr: '제출'
  },
  'common_btn_send_ver': {
    cn: '发送验证码',
    en: 'Send Code',
    kr: '인증번호 발송'
  },
  'common_btn_confirm': {
    cn: '确定',
    en: 'Confirm',
    kr: '결정'
  },
  'common_btn_next_tiao': {
    cn: '下一条',
    en: 'Next {0}',
    kr: '다음'
  },
  'common_btn_know_more': {
    cn: '查看更多',
    en: 'view more about',
    kr: '더 많이 보기'
  },
  'common_btn_i_know': {
    cn: '我知道了',
    en: 'I Know',
    kr: '알겠습니다'
  },
  'common_btn_renewal': {
    cn: '立即续费',
    en: 'Renewal',
    kr: '즉시 요금을 추가하다'
  },
  'common_btn_renewal2': {
    cn: '续费',
    en: 'Renewal',
    kr: '즉시 요금을 추가하다'
  },
  'common_btn_view_details': {
    cn: '查看详情',
    en: 'View details',
    kr: '세부내용 보기'
  }
}

// 表单常用名称
const form = {
  'common_form_phone': {
    cn: '手机号',
    en: 'Phone',
    kr: '휴대폰 번호'
  },
  'common_form_phone_next': {
    cn: '手机号',
    en: 'Phone',
    kr: 'Phone'
  },
  'common_form_Change_moblie': {
    cn: '更换{0}',
    en: 'Change{0}',
    kr: '변경{0}'
  },
  'common_form_remark': {
    cn: '备注',
    en: 'Remark',
    kr: '비고'
  },
  'common_form_login_name_or_phone': {
    cn: '用户名/手机号/邮箱',
    en: 'Username/mobile phone number/email',
    kr: '아이디 / 휴대 전화 번호 / 이메일'
  },
  'common_form_login_pd': {
    cn: '登录密码',
    en: 'Login password',
    kr: '로그인비밀번호'
  },
  'common_form_login_pd2': {
    cn: '密码',
    en: 'password',
    kr: '로그인비밀번호'
  },
  'common_form_设置密码': {
    cn: '设置密码（8至16位包含大小写字母及数字的密码）',
    en: 'Set a password (A password of 8-16 containing uppercase and lowercase letters and digits)',
    kr: '비밀번호 설정(대문자, 소문자 및 숫자를 포함하는 8-16의 비밀번호)'
  },
  'common_form_再次输入密码': {
    cn: '再次输入密码',
    en: 'Enter the password again',
    kr: '비밀번호를 다시 입력하세요'
  },
  'common_form_密码格式错误': {
    cn: '密码格式错误',
    en: 'Password format is wrong',
    kr: '비밀번호 형식이 잘못되었습니다'
  },
  'common_form_identifying_code': {
    cn: '右侧验证码',
    en: 'Identifying code',
    kr: '이미지 인증번호'
  },
  'common_form_company_name': {
    cn: '公司名称(选填)',
    en: 'Company Name',
    kr: '회사 이름 (선택 사항)'
  },
  'common_form_sms_code': {
    cn: '短信验证码',
    en: 'SMS verification code',
    kr: 'SMS verification code'
  },
  'common_form_customer_code': {
    cn: '客户代码',
    en: 'Customer code',
    kr: '고객코드'
  },
  'common_form_email': {
    cn: '邮箱地址',
    en: 'E-mail address',
    kr: '이메일 주소'
  },
  'common_form_email_code': {
    cn: '邮箱验证码',
    en: 'E-mail verification code',
    kr: '이메일 인증 코드'
  },
  'common_form_vr_code': {
    cn: '验证码',
    en: 'verification code',
    kr: '확인 코드'
  },
  'common_form_正确的手机号码': {
    cn: '正确的手机号码',
    en: 'correct phone number',
    kr: '정확한 전화번호'
  },
  'common_form_four-digit': {
    cn: '四位验证码',
    en: 'four-digit verification code',
    kr: '4자리 인증 코드'
  },
  'common_form_password2': {
    cn: '两次密码输入不一致',
    en: 'The two passwords dont match',
    kr: '두 비밀번호가 일치하지 않습니다'
  },
  'common_form_请阅读并勾选协议': {
    cn: '请阅读并勾选协议',
    en: 'Please read and tick the agreement',
    kr: '동의를 읽고 체크해주세요'
  },
  'common_form_please_enter': {
    cn: '请输入{0}',
    en: 'Please enter {0}',
    kr: '{0}을 입력해 주십시오. '
  },
  'common_form_格式错误': {
    cn: '{0}格式错误',
    en: '{0} format error',
    kr: '{0} 잘못된 형식'
  },
  'common_form_Invitation': {
    cn: '邀请码(选填)',
    en: 'Invitation code',
    kr: '초대 코드 (선택 사항)'
  },
  'common_form_please_fillin': {
    cn: '请填写{0}',
    en: 'Please fill in {0}',
    kr: '{0}을 기입해 주십시오. '
  },
  'common_form_please_select': {
    cn: '请选择{0}',
    en: 'Please select {0}',
    kr: '{0}을 선택해 주십시오. '
  },
  'common_form_cannot_empty_by': {
    cn: '{0}不能为空',
    en: 'The {0} cannot be empty',
    kr: '{0}은 빈칸으로 둘 수 없습니다. '
  },
  'common_form_select_All': {
    cn: '全选',
    en: 'Select all',
    kr: '전체 선택'
  },
  'common_form_deselect_All': {
    cn: '全不选',
    en: 'Deselect all',
    kr: '전체 선택 해제'
  }
}

// 登录
const login = {
  'common_login_title': {
    cn: '登录',
    en: 'Sign in',
    kr: '로그인'
  },
  'common_login_login_btn': {
    cn: '去登录',
    en: 'Sign in',
    kr: '로그인'
  },
  'common_login_register_tip': {
    cn: '已有账号？',
    en: 'Already have an account?',
    kr: '이미 계정이 있습니까?'
  },
  'common_login_login_tip': {
    cn: '没有账号？',
    en: 'No account?',
    kr: '계정이 없습니까?'
  },
  'common_login_register': {
    cn: '注册',
    en: 'Register',
    kr: '등록'
  },
  'common_login_首次登录绑定': {
    cn: '首次登录绑定',
    en: 'First login binding',
    kr: '첫 번째 로그인 바인딩'
  },
  'common_login_邮箱找回': {
    cn: '邮箱找回',
    en: 'Retrieve password by email',
    kr: '이메일 검색'
  },
  'common_login_手机号找回': {
    cn: '手机号找回',
    en: 'by mobile',
    kr: '전화번호 검색'
  },
  'common_login_首次登录需绑定': {
    cn: '首次登录需绑定手机号',
    en: 'The first time you log in, you need to bind the phone number',
    kr: '최초 로그인 시 휴대폰 번호를 바인딩해야 합니다.'
  },
  'common_login_钉钉登录': {
    cn: '钉钉登录',
    en: 'DingTalk Login',
    kr: 'DingTalk 로그인'
  },
  'common_login_微信登录': {
    cn: '微信登录',
    en: 'WeChat Login',
    kr: 'WeChat 로그인'
  },
  'common_login_免费注册': {
    cn: '去注册',
    en: 'Register for free',
    kr: '무료 등록'
  },
  'common_login_return_login': {
    cn: '返回登录',
    en: 'Return login',
    kr: '로그인 반환'
  },
  'common_login_erp1': {
    cn: 'ERP1.0客户登录',
    en: 'ERP1.0 customer login',
    kr: 'ERP1.0 클라이언트 로그인'
  },
  'common_login_IP提醒': {
    cn: 'IP提醒',
    en: 'IP to remind',
    kr: 'IP 알림'
  },
  'common_login_dingtalk_reading': {
    cn: '钉钉拉取中，请稍后一下',
    en: 'The Dingtalk is reading, please wait a moment',
    kr: 'Ding Talk를 불러오는 중입니다. 잠시만 기다려 주십시오'
  },
  'common_login_QR_wrong': {
    cn: '二维码有误，请稍后在试',
    en: 'The QR code is wrong, please try again later',
    kr: 'QR코드에 오류가 있습니다. 잠시 후 시도해 주십시오'
  },
  'common_login_click_get': {
    cn: '点击重新获取',
    en: 'Click on the get',
    kr: '다시 받기 클릭'
  },
  'common_login_输入地区模糊查询': {
    cn: '输入地区模糊查询',
    en: 'Enter a region fuzzy query',
    kr: '지역 퍼지 쿼리를 입력하세요.'
  },
  'common_login_forget_password': {
    cn: '忘记密码',
    en: 'Forgot password',
    kr: '비밀번호를 잊으 셨나요'
  },
  'common_login_five_auto_login5天': {
    cn: '5天内自动登录',
    en: 'Automatic login within 5 days',
    kr: '5일 이내 자동 로그인'
  },
  'common_login_I_read_agress': {
    cn: '我已阅读并同意',
    en: 'I have read and agree to',
    kr: '모두 읽었으며 이에 동의합니다'
  },
  'common_login_登录即表明您同意': {
    cn: '登录即表明您同意',
    en: 'By logging in, you agree to ',
    kr: '로그인은 동의한다는 의미입니다'
  },
  'common_login_ServiceAgreement': {
    cn: '《 服务协议 》',
    en: 'The Service Agreement',
    kr: '서비스 약관'
  },
  'common_login_PrivacyPolicy': {
    cn: '《 隐私政策 》',
    en: 'The Privacy Policy',
    kr: '프라이버시 정책'
  },
  'common_login_ckeck_agreement': {
    cn: '请查看并勾选用户协议',
    en: 'Please find and check the user agreement',
    kr: '이용 약관을 확인하고 체크표시를 해 주십시오. '
  },
  'common_login_注册成功': {
    cn: '注册成功',
    en: 'Register successfully',
    kr: '이용 약관을 확인하고 체크표시를 해 주십시오'
  },
  'common_login_初始密码将通过短信发送到您的手机': {
    cn: '初始密码将通过短信发送到您的手机，系统将在3秒后自动登录',
    en: 'The initial password will be sent to your mobile phone via SMS, and the system will automatically log in after 3 seconds',
    kr: '초기 비밀번호는 SMS를 통해 휴대폰으로 전송되며, 시스템은 3초 후 자동으로 로그인됩니다.'
  },
  'common_login_找回密码成功': {
    cn: '找回密码成功',
    en: 'Retrieve password successfully',
    kr: '비밀번호를 성공적으로 검색'
  }
}

const home = {
  'common_home_announcement': {
    cn: '{0}公告{1}',
    en: '{0}Announcement {1}',
    kr: '{0}공지사항{1}'
  },
  'common_home_message_type': {
    cn: '消息类型',
    en: 'message type',
    kr: '메시지 유형'
  },
  'common_home_announcement_type0': {
    cn: '全部',
    en: 'All',
    kr: '전부'
  },
  'common_home_announcement_type1': {
    cn: '系统通知',
    en: 'Systematic',
    kr: '시스템 알림'
  },
  'common_home_announcement_type2': {
    cn: '版本更新',
    en: 'Release version',
    kr: '버전 배포'
  },
  'common_home_announcement_type3': {
    cn: '功能更新',
    en: 'Update function',
    kr: '기능 업데이트'
  },
  'common_home_announcement_type4': {
    cn: '紧急通知',
    en: 'Emergency',
    kr: '긴급공지'
  },
  'common_home_announcement_type5': {
    cn: '其他',
    en: 'Other',
    kr: '기타'
  },
  'common_globalcomp_login_again': {
    cn: '重新登录',
    en: 'Login again',
    kr: '재 등록'
  }
}

const comment = {
  'common_comment_满意度': {
    cn: '您对本页面的满意度是',
    en: 'How satisfied are you with this page',
    kr: '이 페이지에 얼마나 만족하십니까?'
  },
  'common_comment_评分的原因': {
    cn: '您给出此评分的原因是',
    en: 'The reason you gave this rating is',
    kr: '이 점수를 준 이유는'
  },
  'common_comment_功能用途': {
    cn: '功能用途',
    en: 'Functional purpose',
    kr: '기능적 목적'
  },
  'common_comment_数据不准确': {
    cn: '数据不准确',
    en: 'Inaccurate data',
    kr: '부정확한 데이터'
  },
  'common_comment_操作麻烦': {
    cn: '操作麻烦',
    en: 'Troublesome operation',
    kr: '번거로운 작업'
  },
  'common_comment_其他': {
    cn: '其他',
    en: 'Other',
    kr: '다른'
  },
  'common_comment_宝贵的意见': {
    cn: '留下您宝贵的意见',
    en: 'Leave your valuable comments',
    kr: '소중한 의견을 남겨주세요'
  },
  'common_comment_评论反馈': {
    cn: '评论反馈',
    en: 'Comment feedback',
    kr: '댓글 피드백'
  },
  'common_comment_我们已经接收': {
    cn: '我们已经接收到您对于',
    en: 'We have received your',
    kr: '우리는 당신의'
  },
  'common_comment_的培训需求': {
    cn: '的培训需求，如果可以，希望您能留下联系方式，我们会安排同事跟您联系。',
    en: 'training needs, if you can, I hope you can leave your contact information and we will arrange for a colleague to contact you',
    kr: '훈련 필요,가능하시다면 연락처를 남겨주시면 동료가 연락드릴 수 있도록 조치하겠습니다.'
  },
  'common_comment_我们怎么称呼您': {
    cn: '我们怎么称呼您',
    en: 'What do we call you',
    kr: '우리는 당신을 뭐라고 부르나요'
  },
  'common_comment_请输入称呼': {
    cn: '请输入称呼',
    en: 'Enter your name',
    kr: '제목을 입력하세요'
  },
  'common_comment_先生': {
    cn: '先生',
    en: 'male',
    kr: '남성'
  },
  'common_comment_女士': {
    cn: '女士',
    en: 'female',
    kr: '숙녀'
  },
  'common_comment_如何联系您': {
    cn: '如何联系您',
    en: 'How to contact you',
    kr: '연락 방법'
  },
  'common_comment_您关注的问题': {
    cn: '您关注的问题',
    en: 'Your concern',
    kr: '당신의 관심사'
  },
  'common_comment_请输入问题': {
    cn: '请输入问题',
    en: 'Please enter a question',
    kr: '질문을 입력하세요'
  },
  'common_comment_提交': {
    cn: '提交',
    en: 'submit',
    kr: '제출하다'
  },
  'common_comment_不留言': {
    cn: '不留言',
    en: 'Do not leave a message',
    kr: '메시지를 남기지 마십시오'
  },
  'common_comment_我要培训': {
    cn: '我要培训',
    en: 'I want to train',
    kr: '나는 훈련하고 싶다'
  },
  'common_comment_温馨提示': {
    cn: '温馨提示',
    en: 'Tips',
    kr: '팁'
  },
  'common_comment_提交成功': {
    cn: '提交成功',
    en: 'Submitted successfully',
    kr: '성공적으로 제출됨'
  },
  'common_comment_手机号': {
    cn: '请输入正确的手机号',
    en: 'please enter a valid phone number',
    kr: '유효한 전화 번호를 입력하세요'
  },
  'common_comment_请评分': {
    cn: '请评分',
    en: 'Please rate',
    kr: '평가 바랍니다'
  },
  'common_comment_不能再拖啦': {
    cn: '不能再拖啦，超出可拖动区域啦',
    en: 'Can’t drag anymore, it’s beyond the draggable area',
    kr: '더 이상 끌 수 없습니다. 끌 수 있는 영역을 벗어났습니다.'
  }
}
// 下载中心
const download = {
  'down_center': {
    cn: '下载中心',
    en: 'Download center',
    kr: '다운로드 센터'
  },
  'common_download': {
    cn: '下载',
    en: 'Download',
    kr: '다운로드'
  },
  'down_search_export_title': {
    cn: '导出文件准备中',
    en: 'Export file in preparation',
    kr: '내보내기 파일 준비 중'
  },
  'down_search_export_content_success_1': {
    cn: '您可以选择',
    en: 'You can choose',
    kr: '당신은 선택할 수 있습니다'
  },
  'down_search_export_content_success_2': {
    cn: '立即下载',
    en: 'Download now',
    kr: '지금 다운로드'
  },
  'down_search_export_content_success_3': {
    cn: '或者在',
    en: 'or in',
    kr: '또는 안에'
  },
  'down_search_export_content_1': {
    cn: '准备工作会在后台进行，您可以先进行其他操作；',
    en: 'Preparations are performed in the background. You can perform other operations first.',
    kr: '준비작업은 배경에서 진행되며 당신은 먼저 기타 작업을 할수 있다.'
  },
  'down_search_export_content_2': {
    cn: '文件下载成功后会提醒您下载',
    en: 'You will be reminded to download the file when it is successfully downloaded',
    kr: '파일을 성공적으로 다운로드했을 때, 다운로드하라는 메시지가 표시됩니다'
  },
  'down_search_export_content_3': {
    cn: '您也可以稍后到',
    en: 'You can also come later',
    kr: '잠시 후에 오셔도 됩니다'
  },
  'down_search_export_look': {
    cn: '查看',
    en: 'To view',
    kr: '보기'
  },
  'down_search_export_success': {
    cn: '导出文件准备完成',
    en: 'Export file ready',
    kr: '내보내기 파일 준비'
  }
}

// var b = a.replace(/([\)\(：\u4e00-\u9fa5\}a-zA-Z]+)([\s]+)([a-zA-Z\)\(：\{\uac00-\ud7ff]+)/g, '$1@$3').replace(/\n/g,'^').split('^')

export default {
  ...system,
  ...conj,
  ...btn,
  ...home,
  // ...status,
  ...download,
  ...form,
  ...login,
  ...comment
}
